import React from 'react';

import {Link} from '../../../../lib/routes';

import {linkClass} from './link-style';

type Props = {
	args: string[];
};

// {@specie dwarf, дварфов}
export const SpeciePlugin: React.FC<Props> = ({args}) => {
	const [id, ...rest] = args;
	const title = rest.join(', ') || id;
	return (
		<Link route="specie" params={{id}} title={title} className={linkClass('specie')}>
			{title}
		</Link>
	);
};
